module.exports = "/assets/41df9fc99c93dd200f33c9ed71ec692c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MK.png
// module id = 1617
// module chunks = 0